export enum GenerateLabelModal {
  GetShippingLabelModal = 'getShippingLabel',
  DropOffTypeSelectionModal = 'dropOffTypeSelection',
  ConfirmationModal = 'confirmation',
  AddressModal = 'address',
  ShippingContactModal = 'shippingContact',
  CourierPickUpDateSelectionModal = 'courierPickUpDateSelection',
  DigitalLabelTypeSelectionModal = 'digitalLabelTypeSelection',
  ReturnTheOrder = 'returnTheOrder',
  ReturnCurrencyConversionModal = 'returnCurrencyConversionModal',
  ShippingDiscountModal = 'shippingDiscountModal',
  DropOffPointMapModal = 'dropOffPointMapModal',
  OpenQrCodeModal = 'openQrCodeModal',
  OpenDigitalLabelOfferModal = 'openDigitalLabelOfferModal',
  TaxpayerRestrictionModal = 'taxpayerRestrictionModal',
  ActivateBalanceModal = 'activateBalanceModal',
  EstimatedRefundModal = 'estimatedRefundModal',
  CarrierChangeModal = 'carrierChangeModal',
  UnknownErrorModal = 'unknownErrorModal',
  DropOffPointTypeSelectionModal = 'dropOffPointTypeSelectionModal',
  GenericErrorModal = 'genericErrorModal',
  CancelOrderModal = 'cancelOrderModal',
  None = 'none',
}

export enum LabelType {
  LabelTypePdf = 1,
  LabelTypeCode = 2,
  LabelTypeQr = 3,
}

export enum DeliveryType {
  Home = 1,
  PickupPoint = 2,
  NoShipping = 3,
  Custom = 4,
}

export enum DistanceUnitEnum {
  Kilometers = 'km',
  Meters = 'm',
  Miles = 'mi',
  Feet = 'ft',
}

export enum DropOffPointType {
  Home = 1,
  Shop = 2,
}

export enum DropOffTypeKey {
  Mailbox = 'mailbox',
  PostOffice = 'postoffice',
  Home2Home = 'home2home',
  ReusablePackage = 'reusablepackage',
  MyOwnPackage = 'myownpackage',
  ContactlessDropoff = 'contactlessdropoff',
}

export enum DropOffsPointType {
  Point = 1,
  Home = 2,
}

export enum DropOffType {
  Point = 'point',
  Home = 'home',
  PostOffice = 'postoffice',
  Mailbox = 'mailbox',
}

export enum DeliveryOptionChangeRequestStatus {
  Accepted = 10,
  Cancelled = 20,
}

export enum DeadlineExtensionStatus {
  Pending = 1,
  Accepted = 10,
  Cancelled = 20,
}

export enum ShipmentStatus {
  New = 1,
  Estimated = 100,
  InstructionsConfirmed = 150,
  LabelProcessing = 200,
  LabelFailed = 210,
  LabelProcessed = 220,
  LabelSent = 230,
  TrackingPending = 250,
  Shipped = 300,
  HeldAtPostOffice = 310,
  LostParcel = 350,
  Delivered = 400,
  CancelDone = 500,
  ReturnToSender = 600,
  ReturnToSenderAvailableForPickup = 610,
  CancelFailed = 620,
  ReturnToSenderDelivered = 625,
  ReturnToSenderCompleted = 630,
  ShippedToFacility = 700,
  ArrivedAtFacility = 710,
  VerificationSuccessful = 720,
  VerificationFailed = 730,
  ShippedFromFacility = 740,
}

export enum ShipmentEntryType {
  Preliminary = 20,
  Factual = 1,
  Return = 30,
}

export enum ShipmentDeliveryType {
  Home = 1,
  Pudo = 2,
}

export enum LabelOptionsLabelType {
  Digital = 'digital',
  Printable = 'printable',
  Code = 'code',
}

export enum PackagingTypes {
  MyOwnPackage = 'my_own_package',
  ReusablePackage = 'resusable_package',
}

export enum PrinterRequirement {
  PrinterRequired = 'printer_required',
  PrinterOptional = 'printer_optional',
  PrinterNotRequired = 'printer_not_required',
}

export enum ModalOrigin {
  DropOffTypeSelection = 'DropOffTypeSelection',
  GenerateLabel = 'GenerateLabelModal',
}

export enum TransactionSide {
  Buyer = 'buyer',
  Seller = 'seller',
}

export enum PhoneRequirement {
  Disabled = 'disabled',
  Optional = 'optional',
  Mandatory = 'mandatory',
}

export enum ReturnShippingOption {
  Integrated = 'integrated',
  Custom = 'custom',
}

export enum ReturnShippingOptionPricing {
  RefundSubtotal = 'refund_subtotal',
  Postage = 'postage',
  RefundTotal = 'refund_total',
}

export enum DistanceType {
  Nearby = 'nearby_carriers',
  Distant = 'distant_carriers',
  Unknown = 'unknown_distance_carriers',
}

export enum RestrictionStatus {
  Warning = 'warning',
  Severe = 'severe',
}
